const swiperFactsAndWallOfFame = {
    swiperInstance: null,
    swiperInstancePagination: null,

    init: () => {
        import('swiper/bundle').then(({Swiper}) => {

            let domEl = document.getElementById('js-swiper-facts');
            let domElPagination = document.getElementById('js-swiper-facts-pagination');

            if (domEl && domElPagination) {
                const paginationParams = getSwiperPaginationParams();
                const params = getSwiperParams();

                swiperFactsAndWallOfFame.swiperInstancePagination = new Swiper(domElPagination, paginationParams);   //NOSONAR
                swiperFactsAndWallOfFame.swiperInstance = new Swiper(domEl, params);   //NOSONAR

                // actions on slideChange of main swiper
                swiperFactsAndWallOfFame.swiperInstance.on('slideChange', function () {
                    // if (this.activeIndex % 2) {
                    //     // domEl.classList.add('swiper-container--positive');
                    //     domElPagination.classList.add('swiper-container--positive');
                    // } else {
                    //     // domEl.classList.remove('swiper-container--positive');
                    //     domElPagination.classList.remove('swiper-container--positive');
                    // }
                    let activeIndex = this.realIndex;
                    swiperFactsAndWallOfFame.swiperInstancePagination.slideTo(activeIndex, 500, false);
                });

                // actions on slideChange of thumbs
                swiperFactsAndWallOfFame.swiperInstancePagination.on('slideChange', function () {
                    let activeIndex = this.realIndex;
                    swiperFactsAndWallOfFame.swiperInstance.slideTo(activeIndex, 500, false);
                });
            }
        })
    }
};

const getSwiperPaginationParams = () => {
    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 0,
        slidesPerView: 'auto',
        speed: 500,
        a11y: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true
    };
};

const getSwiperParams = () => {

    return {
        watchOverflow: true,
        centeredSlides: true,
        spaceBetween: 32,
        slidesPerView: 1,
        speed: 500,
        slideToClickedSlide: true,
        resizeObserver: true,
        a11y: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        mousewheel: {
            forceToAxis: true
        },
        grabCursor: true,
        autoHeight: true,
        thumbs: {
            swiper: swiperFactsAndWallOfFame.swiperInstancePagination,
        },
        pagination: {
            el: '.swiper-pagination',
            clickable: true,
            type: 'progressbar',
        }
    }
}

export default swiperFactsAndWallOfFame;